var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'youtube')?_c('embed-youtube-video',_vm._b({},'embed-youtube-video',_vm.$props,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }